import AuthInterceptor from "./AuthInterceptor";

const vetClient = {
  name: "vetService",
  baseUrl:process.env.REACT_APP_BASE_URL,
  timeout: 60000,
  addRequestId: true,
  requestIdHeaderName: "X-Correlation-Id",
  interceptor:new AuthInterceptor(),
};

const clients=[vetClient];

export default clients;